// Named imports from the "react" module (when combined with the import maps) 
// trip up Vite's module loader, so we explicitly export the module here in both forms.
// The import map rewriter will redirect all external "react" imports to this file, which 
// will simply act as a proxy for the original imports.
import React from "react";
export {
    act,
    captureOwnerStack,
    createContext,
    createElement,
    createRef,
    cloneElement,
    isValidElement,
    forwardRef,
    lazy,
    memo,
    use,
    useActionState,
    useCallback,
    useContext,
    useDebugValue,
    useDeferredValue,
    useEffect,
    useId,
    useImperativeHandle,
    useInsertionEffect,
    useLayoutEffect,
    useMemo,
    useOptimistic,
    useReducer,
    useRef,
    useState,
    useSyncExternalStore,
    useTransition,
    startTransition,
    Children,
    Fragment,
    StrictMode,
    Suspense,
    version,
    Profiler,
} from "react";
export default React;